"use client";

import { ArrowUp, ArrowDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

interface SortableTableHeadProps
  extends React.ComponentProps<typeof TableHead> {
  column: string;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  onSort: (column: string) => void;
  align?: "left" | "right";
}

export function SortableTableHead({
  column,
  sortColumn,
  sortDirection,
  onSort,
  align = "left",
  children,
  className,
  ...props
}: SortableTableHeadProps) {
  const isActive = sortColumn === column;

  return (
    <TableHead
      className={cn("cursor-pointer hover:bg-muted/50", className)}
      onClick={() => onSort(column)}
      {...props}
    >
      <div
        className={cn(
          "flex items-center gap-1",
          align === "right" && "justify-end",
        )}
      >
        {children}
        {isActive &&
          (sortDirection === "asc" ? (
            <ArrowUp className="h-4 w-4" />
          ) : (
            <ArrowDown className="h-4 w-4" />
          ))}
      </div>
    </TableHead>
  );
}
